<mat-card appearance="outlined" [class.disabled]="hasNotification" [class.highlighted]="tourStop.isHighlighted"
          [class.has-error]="tourStop.hasError" [class.on-demand]="tourStop.isOnDemandTransport"
          (click)="open()">
  <mat-card-content>
    <div class="tour-stop-row">

      <!-- Left column -->
      <div class="tour-stop-left-col">

        <ng-container *ngIf="tourStop.isHomeDelivery else transportTourStop">
          <ng-container *ngIf="tourStop.isBatchScanPossible else notBatchScan">

            <!-- Gruppengepäck -->
            <div>
              <span>{{ 'BatchScanningShorthand' | translate}}</span>
            </div>

            <!-- ABH/ZUS -->
            <div>
              <span>{{ 'HomeDeliveryKindShorthand.' + tourStop.homeDelivery.kind | translate}}</span>
            </div>
          </ng-container>
          <ng-template #notBatchScan>
            <!-- TzT -->
            <div>
              <span>{{ 'TourStopKindShorthand.' + tourStop.kind | translate}}</span>
            </div>
            <!-- ABH/ZUS -->
            <div>
              <span>{{ 'HomeDeliveryKindShorthand.' + tourStop.homeDelivery.kind | translate}}</span>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #transportTourStop>
          <div>
            <span>{{ 'TourStopKindShorthand.' + tourStop.kind | translate}}</span>
          </div>
          <div>
            <span>{{ tourStop.transport.name }}</span>
          </div>
        </ng-template>
      </div>

      <!-- Right column -->
      <div class="tour-stop-right-col">

        <!-- Time frame -->
        <div class="tour-stop-info" *ngIf="tourStop.timeFrame">
          <mat-icon>access_time</mat-icon>
          <div><span>{{ tourStop.timeFrame }}</span></div>
        </div>

        <!-- Associated name -->
        <div class="tour-stop-info" *ngIf="tourStop.isHomeDelivery">
          <mat-icon>person</mat-icon>
          <div><span>{{ tourStop.associatedName }}</span></div>
        </div>

        <!-- Address -->
        <div class="tour-stop-info">
          <mat-icon>location_on</mat-icon>
          <div>
            <div><span>{{ tourStop.address.street }} {{ tourStop.address.streetNumber }}</span></div>
            <div><span>{{ tourStop.address.zipCode }} {{ tourStop.address.city }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
